import { createAction } from '@reduxjs/toolkit';

export const getMainDbSuccess = createAction('GET_MAIN_DB_SUCCESS', function prepare(items) {
    return {
        payload: items
    }

})

